{
  "schemaVersion": 1,
  "writablePaths": [
    {
      "pattern": "player.identity.name",
      "owner": "player",
      "phases": ["main", "player"]
    },
    {
      "pattern": "player.identity.pronouns",
      "owner": "player",
      "phases": ["main", "player"]
    },
    {
      "pattern": "player.identity.origin",
      "owner": "player",
      "phases": ["main", "player"]
    },
    {
      "pattern": "player.vitals.health",
      "owner": "player",
      "phases": ["main", "player"]
    },
    {
      "pattern": "player.vitals.stamina",
      "owner": "player",
      "phases": ["main", "player"]
    },
    {
      "pattern": "player.proficiency.great_sword",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.long_sword",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.sword_shield",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.dual_blades",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.hammer",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.hunting_horn",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.lance",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.gunlance",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.switch_axe",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.charge_blade",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.insect_glaive",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.light_bowgun",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.heavy_bowgun",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "player.proficiency.bow",
      "owner": "player",
      "phases": ["player"]
    },
    {
      "pattern": "characters.*.identity.name",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.identity.pronouns",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.identity.occupation",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.identity.affiliation",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.identity.title",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.presence.status",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.presence.location",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.presence.lastSeenAt",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.appearance",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.status.current",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.status.health",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.status.stamina",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.relations.*.label",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.relations.*.affinity.current",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.relations.*.notes",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.relations.*.knowsTargetName",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.bio.biography",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.bio.recentEvents",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.bio.currentMotive",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.bio.shortTermGoal",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "characters.*.bio.longTermGoal",
      "owner": "character",
      "phases": ["npc"]
    },
    {
      "pattern": "monsters.*.name",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.individualName",
      "owner": "monster",
      "phases": ["monster"]
    },
    {
      "pattern": "monsters.*.health",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.rage",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.fatigue",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.parts.*.durability",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.parts.*.broken",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.tailSevered",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.location",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    {
      "pattern": "monsters.*.scars",
      "owner": "monster",
      "phases": ["monster"]
    },
    {
      "pattern": "monsters.*.territory",
      "owner": "monster",
      "phases": ["monster"]
    },
    {
      "pattern": "monsters.*.lastSeenAt",
      "owner": "monster",
      "phases": ["monster"]
    },
    {
      "pattern": "monsters.*.status",
      "owner": "monster",
      "phases": ["main", "monster"]
    },
    { "pattern": "scene.*", "owner": "scene", "phases": ["main", "misc"] },
    { "pattern": "gameTime.*", "owner": "time", "phases": ["main", "misc"] },
    { "pattern": "worldEvents", "owner": "world", "phases": ["misc"] },
    {
      "pattern": "narrativeMemory.facts",
      "owner": "memory",
      "phases": ["misc"]
    }
  ],
  "forbiddenPaths": [
    "player.hunter.*",
    "player.wallet.*",
    "player.derived.*",
    "player.equipped.*.numericMeta",
    "itemRegistry.definitions.*.meta",
    "tasks.activeTaskId",
    "tasks.available.*.status",
    "tasks.available.*.reward",
    "tasks.history.*.reward",
    "meta.*"
  ],
  "helpers": {
    "acquireItem": ["main", "item"],
    "consumeItem": ["main", "item"],
    "completeTask": ["main", "entry"],
    "failTask": ["main", "entry"],
    "proposeTask": ["main", "misc"],
    "transferZenny": ["main"],
    "advanceTime": ["main", "misc"],
    "monsterState": ["main", "entry", "monster"],
    "upsertCharacter": ["entry"]
  }
}
